import { IconPropsType } from "./type";

export const OpenedBook = ({
  size = 24,
  color = "currentColor",
}: IconPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3.66667V13"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.99998 11C1.82317 11 1.6536 10.9298 1.52858 10.8047C1.40355 10.6797 1.33331 10.5101 1.33331 10.3333V1.66667C1.33331 1.48986 1.40355 1.32029 1.52858 1.19526C1.6536 1.07024 1.82317 1 1.99998 1H5.33331C6.04056 1 6.71883 1.28095 7.21893 1.78105C7.71903 2.28115 7.99998 2.95942 7.99998 3.66667C7.99998 2.95942 8.28093 2.28115 8.78103 1.78105C9.28113 1.28095 9.9594 1 10.6666 1H14C14.1768 1 14.3464 1.07024 14.4714 1.19526C14.5964 1.32029 14.6666 1.48986 14.6666 1.66667V10.3333C14.6666 10.5101 14.5964 10.6797 14.4714 10.8047C14.3464 10.9298 14.1768 11 14 11H9.99998C9.46955 11 8.96084 11.2107 8.58577 11.5858C8.21069 11.9609 7.99998 12.4696 7.99998 13C7.99998 12.4696 7.78927 11.9609 7.41419 11.5858C7.03912 11.2107 6.53041 11 5.99998 11H1.99998Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
